import { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
class ReactResizeObserver extends PureComponent {
    constructor() {
        super(...arguments);
        this.resizeObserver = null;
        this.width = 0;
        this.height = 0;
        this.onResize = (entries) => {
            const { onResize, resizeProp } = this.props;
            const { target, contentRect: { width, height }, } = entries[0];
            /**
             * getBoundingClientRect return wrong size in transform case.
             */
            // const { width, height } = target.getBoundingClientRect();
            const fixedWidth = Math.floor(width);
            const fixedHeight = Math.floor(height);
            if ((this.width !== fixedWidth && ['width', 'both'].includes(resizeProp)) ||
                (this.height !== fixedHeight && ['height', 'both'].includes(resizeProp))) {
                this.width = fixedWidth;
                this.height = fixedHeight;
                if (onResize) {
                    onResize(fixedWidth, fixedHeight, target);
                }
            }
        };
    }
    componentDidMount() {
        this.onComponentUpdated();
    }
    componentDidUpdate() {
        this.onComponentUpdated();
    }
    componentWillUnmount() {
        this.destroyObserver();
    }
    onComponentUpdated() {
        const { disabled } = this.props;
        const element = findDOMNode(this);
        if (!this.resizeObserver && !disabled && element) {
            // Add resize observer
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(element);
        }
        else if (disabled) {
            // Remove resize observer
            this.destroyObserver();
        }
    }
    destroyObserver() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    render() {
        const { children = null } = this.props;
        return children;
    }
}
ReactResizeObserver.defaultProps = {
    resizeProp: 'both',
};
export default ReactResizeObserver;
